/**************************************************
 * Nombre:       Dialogo_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Producto from "../../Formularios/Catalogo/Formulario_Producto";
import Formulario_Tipo from "../../Formularios/Formulario_Tipo";
import {useEffect} from "react";
import {guardarRegistro} from "../../../Modulo_Algolia/Funciones/guardarRegistro";

const Dialogo_Producto = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data
        nuevoAviso({aviso: 'Imagen subida'})

        entidad.etiquetas = obtenerEtiquetas(entidad)


        let dox = await guardarDoc('productos', entidad)
        entidad.id = dox.data
        await guardarRegistro({obj: entidad, coleccion: 'productos', id: dox.data})
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    const obtenerEtiquetas = (ent) =>{

        let arr = ent.etiquetas ? ent.etiquetas : [];

        if (ent.tipo){
            arr.push(ent.tipo)
        }
        if (ent.reserva){
            arr.push(ent.reserva)
        }
        if (ent.origen){
            arr.push(ent.origen)
        }
        if (ent.madurez){
            arr.push(ent.madurez)
        }

        let set = new Set(arr)
        let array = [...set];

        return array


    }


    const borrar = async () => {
        await borrarDoc('productos', datos.id)
        terminar({aviso: 'Producto borrado'})
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Producto props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Producto